import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Home|NewsArticleDetail|';
const sharedProperties: Pick<LocDef, 'shared' | 'portal' | 'htmlAllowed' | 'feature'> = {
	shared: false,
	portal: 'CP',
	htmlAllowed: false,
	feature: HubFeature.CandidateAccess,
};

type NewsArticleDetailLocName =
	| 'CPNewsArticleDetailButtonGoBack'
	| 'CPNewsArticleDetailContentDetailsNotFound';

export const cpNewsArticleDetailLocs: LocDefs<NewsArticleDetailLocName> = {
	CPNewsArticleDetailButtonGoBack: {
		defaultValue: 'Go Back',
		description:
			'The text inside the button in the top right corner of the news article details page.',
		displayPath: `${pathStart}Button Go Back`,
		displayType: 'Button',
		legacyName: 'CandidateAccess/Home.NewsArticleDetail.Button.GoBack',
		...sharedProperties,
	},
	CPNewsArticleDetailContentDetailsNotFound: {
		defaultValue: 'Article details not found',
		description: 'The text displayed when the article details are not found.',
		displayPath: `${pathStart}Content Details Not Found`,
		displayType: 'Content',
		legacyName: 'CandidateAccess/Home.NewsArticleDetail.Content.DetailsNotFound',
		...sharedProperties,
	},
};

export type CpNewsArticleDetailLocType = LocMap<NewsArticleDetailLocName>;

export const LOC_KEYS = MapLocKeys<NewsArticleDetailLocName>(cpNewsArticleDetailLocs);
